// Removed unused React imports
import { Button } from "@/components/ui/button";
import { fetchAPI } from "@/lib/api";
import { Link } from "react-router-dom";
import { InquiryForm } from "@/components/InquiryForm";
import ladakhImage from "@/assets/cta-bg.jpg";
import ladakhImageWebp from "@/assets/cta-bg.webp";

export const CallToAction = () => {

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <picture>
          <source srcSet={ladakhImageWebp} type="image/webp" />
          <img 
            src={ladakhImage}
            alt="Ladakh monastery in the Himalayas"
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-r from-indigo/90 via-indigo/80 to-primary/70" />
      </div>

      {/* Content */}
      <div className="relative container mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary-foreground mb-6">
            Ready to Begin Your
            <br />
            <span className="text-gradient-sacred">Spiritual Journey?</span>
          </h2>
          <p className="text-primary-foreground/80 text-lg leading-relaxed mb-8">
            Every journey begins with a single step. Let us guide you toward
            the transformation you seek. Connect with our team to discuss
            your spiritual aspirations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/circuits">
              <Button variant="sacred" size="xl">
                Explore Journeys
              </Button>
            </Link>
            <InquiryForm 
              trigger={
                <Button variant="hero" size="xl">
                  Begin Your Journey
                </Button>
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};
